const stripHtmlTagsFrom = htmlStr => {
  const div = document.createElement('div');

  div.innerHTML = htmlStr;

  return div.textContent || div.innerText || '';
};

const News = ({ title, description, link, image }) => ({
  title,
  subtitle: stripHtmlTagsFrom(description),
  url: link,
  image,
});

export { News };
